const isFiniteNumber = value =>
  typeof value === 'number' && Number.isFinite(value);

const getResultPrice = result => {
  if (result && isFiniteNumber(result.from_price)) return result.from_price;
  if (result && isFiniteNumber(result.bookable_nightly_price)) {
    return result.bookable_nightly_price;
  }
  const listings = result && result.listings;
  const firstListing = Array.isArray(listings) ? listings[0] : null;
  if (firstListing && isFiniteNumber(firstListing.bookable_nightly_price)) {
    return firstListing.bookable_nightly_price;
  }
  return null;
};

const buildListingHref = (result, queryString) => {
  if (result.room_type_id) {
    return `/listings/${result.slug}/unit/${
      result.default_unit_id
    }${queryString}&room=${result.room_type_id}`;
  }
  return `/listings/${result.slug}${queryString}`;
};

const countSearchResultProperties = results => {
  const propertyIds = new Set();
  if (!Array.isArray(results)) return propertyIds.size;

  results.forEach(result => {
    const property =
      result && result.property && result.property.id !== undefined
        ? result.property
        : null;
    const propertyId = property ? property.id : result && result.id;
    if (propertyId !== undefined && propertyId !== null) {
      propertyIds.add(String(propertyId));
    }
  });

  return propertyIds.size;
};

module.exports = {
  getResultPrice,
  buildListingHref,
  countSearchResultProperties
};
